module.exports = __webpack_public_path__ + "img/sina.0e458a27.png";